<template>
  <div class="container">
    <button v-on:click="count++">
      {{ count > 1 ? `💀 Ouch!` : `You clicked me ${count} times. 👀` }}
    </button>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('Component mounted.')
  },

  data: function() {
    return {
      count: 0
    }
  }
}
</script>
